"use strict";
exports.__esModule = true;
exports.ActivityField = exports.ActivityDefinitionDocument = void 0;
var ActivityDefinitionDocument = /** @class */ (function () {
    function ActivityDefinitionDocument(org_id, name, label, description, icon, fields, created_at, updated_at, created_by, updated_by, show_in_activity_grid, show_in_settings, is_conversation, is_public, // Can be seen by others, other than creator
    is_readonly_definition, // Can be edited or not
    display_field, // Field that will be used in main display
    can_be_logged_predated, //Previously dated activity saved to db, like messages. In logged case whatsapp will be not sent only stored. For activity it will be: is_log
    is_active) {
        if (fields === void 0) { fields = []; }
        if (show_in_activity_grid === void 0) { show_in_activity_grid = true; }
        if (show_in_settings === void 0) { show_in_settings = true; }
        if (is_conversation === void 0) { is_conversation = false; }
        if (is_public === void 0) { is_public = true; }
        if (is_readonly_definition === void 0) { is_readonly_definition = false; }
        if (display_field === void 0) { display_field = ''; }
        if (can_be_logged_predated === void 0) { can_be_logged_predated = false; }
        if (is_active === void 0) { is_active = true; }
        this.org_id = org_id;
        this.name = name;
        this.label = label;
        this.description = description;
        this.icon = icon;
        this.fields = fields;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.created_by = created_by;
        this.updated_by = updated_by;
        this.show_in_activity_grid = show_in_activity_grid;
        this.show_in_settings = show_in_settings;
        this.is_conversation = is_conversation;
        this.is_public = is_public;
        this.is_readonly_definition = is_readonly_definition;
        this.display_field = display_field;
        this.can_be_logged_predated = can_be_logged_predated;
        this.is_active = is_active;
    }
    ActivityDefinitionDocument.fromJSON = function (json) {
        var definition = new ActivityDefinitionDocument('', '', '', '', '', [], 0, 0, '', '', true, true, false, true, false, '', false, true);
        if (json) {
            definition.org_id = json.org_id ? json.org_id : '';
            definition.name = json.name ? json.name : '';
            definition.label = json.label ? json.label : '';
            definition.description = json.description ? json.description : '';
            definition.icon = json.icon ? json.icon : '';
            definition.fields = json.fields ? json.fields : [];
            definition.created_at = json.created_at ? json.created_at : 0;
            definition.updated_at = json.updated_at ? json.updated_at : 0;
            definition.created_by = json.created_by ? json.created_by : '';
            definition.updated_by = json.updated_by ? json.updated_by : '';
            definition.show_in_activity_grid = json.show_in_activity_grid !== undefined ? json.show_in_activity_grid : true;
            definition.show_in_settings = json.show_in_settings !== undefined ? json.show_in_settings : true;
            definition.is_conversation = json.is_conversation !== undefined ? json.is_conversation : false;
            definition.is_public = json.is_public !== undefined ? json.is_public : true;
            definition.is_readonly_definition = json.is_readonly_definition !== undefined ? json.is_readonly_definition : false;
            definition.display_field = json.display_field !== undefined ? json.display_field : '';
            definition.can_be_logged_predated = json.can_be_logged_predated !== undefined ? json.can_be_logged_predated : false;
            definition.is_active = json.is_active !== undefined ? json.is_active : true;
        }
        return definition;
    };
    return ActivityDefinitionDocument;
}());
exports.ActivityDefinitionDocument = ActivityDefinitionDocument;
var ActivityField = /** @class */ (function () {
    function ActivityField(name, label, description, field_type, is_readonly_definition, is_readonly_value, required, rules, option) {
        this.name = name;
        this.label = label;
        this.description = description;
        this.field_type = field_type;
        this.is_readonly_definition = is_readonly_definition;
        this.is_readonly_value = is_readonly_value;
        this.required = required;
        this.rules = rules;
        this.option = option;
    }
    ActivityField.fromJSON = function (json) {
        var field = new ActivityField('', '', '', null, false, false, false);
        if (json) {
            field.name = json.name ? json.name : '';
            field.label = json.label ? json.label : '';
            field.description = json.description ? json.description : '';
            field.field_type = json.field_type ? json.field_type : null;
            field.is_readonly_definition = json.is_readonly_definition !== undefined ? json.is_readonly_definition : false;
            field.is_readonly_value = json.is_readonly_value !== undefined ? json.is_readonly_value : false;
            field.required = json.required !== undefined ? json.required : false;
            field.rules = json.rules ? json.rules : null;
            field.option = json.option ? json.option : [];
        }
        return field;
    };
    return ActivityField;
}());
exports.ActivityField = ActivityField;
